import { ReactNode, useMemo } from 'react';
import useGlobalization, { Globalization } from '../hooks/useGlobalization';
import { TranslationContext, TranslationContextType } from './TranslationContext';

type TranslationProviderProps = {
  children: ReactNode;
};

const DEFAULT_LOCALE = 'en-US';

/**
 * Provider component that makes translation functions available throughout the app.
 * Locale is read once from `window.fsl_locale` (set by AEM before the app mounts).
 */
export const TranslationProvider = ({ children }: TranslationProviderProps) => {
  const locale = window.fsl_locale ?? DEFAULT_LOCALE;

  const globalizationSettings: Globalization = { locale };

  const { t, formatCurrency, formatNumber, formatDate, formatDateMonthYear, formatMonthDateYear } =
    useGlobalization(globalizationSettings);

  const contextValue: TranslationContextType = useMemo(
    () => ({
      locale,
      t,
      formatCurrency,
      formatNumber,
      formatDate,
      formatDateMonthYear,
      formatMonthDateYear,
    }),
    [locale, t, formatCurrency, formatNumber, formatDate, formatDateMonthYear, formatMonthDateYear],
  );

  return <TranslationContext.Provider value={contextValue}>{children}</TranslationContext.Provider>;
};
